module.exports = __webpack_public_path__ + "static/media/cloud6@2x.7f6c21d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/AttractLoopView/cloud6@2x.png
// module id = 872
// module chunks = 0